<template>
  <div>
    <!-- <div class="ai_question cursor_pointer">
      <el-image class="ai_question_icon" :src="iconPath('ai_question_icon.png')" @click="showAiQuestion"></el-image>
    </div> -->
    <div class="right_box flex flexcolumn FlexEvenly">
      <div class="right_one flex Flexjustify flexcolumn Flexalign border_none cursor_pointer ml-4"
        v-for="(item, index) in menuList" :key="index" :class="[selectedMenu == item.menu ? 'active_right_one' : '']"
        @click="changeMenu(item)" @mouseenter="showActive(item)" @mouseleave="hideActive">
        <el-image class="back_img" :src="iconPath(selectedMenu == item.menu ? item.activeIcon : item.icon)"></el-image>
        <div class="mt-5">{{ item.text }}</div>
        <div class="split_line" v-if="index != menuList.length - 1"></div>
        <div class="qrcode_box" v-if="(selectedMenu == 8 || selectedMenu == 9) && selectedMenu == item.menu">
          <!-- <qrcode-vue :value="item.qrCodeValue" :size="80"></qrcode-vue> -->
           <el-image class="companionTeacherQrcode" :src="item.qrCodeValue"></el-image>
        </div>
        <div class="qrcode_box" v-if="selectedMenu == 5 && selectedMenu == item.menu">
          <el-image class="companionTeacherQrcode" :src="companionTeacherQrcode"></el-image>
        </div>
        <div class="qrcode_box connect_phone" v-if="(selectedMenu == 6 || selectedMenu == 7) && selectedMenu == item.menu">
          <div>{{item.text}}</div>
          <div class="mt-5">{{item.phone}}</div>
        </div>
        <!-- <div class="qrcode_box connect_phone" v-if="selectedMenu == 7 && selectedMenu == item.menu">
          <div>韩老师</div>
          <div class="mt-5">18123637079</div>
        </div> -->
      </div>
      <feedback ref="feedback"></feedback>
      <aiQuestionPopup ref="aiQuestionPopup" :initial-position="{ x: windowWidth - 480, y: windowHeight - 300 }"></aiQuestionPopup>
    </div>
  </div>
</template>

<script>
import feedback from "../popup/feedback.vue";
// import QrcodeVue from "qrcode.vue";
import aiQuestionPopup from "../aiQuestion/aiQuestionPopup.vue";
import * as config from "@/config/config";
export default {
  name: "GjkcH5MoeRight",
  props: {
    // 是否展示客服
    // showCustomer: {},
    // companionTeacherQrcode: {}, // 伴学师二维码
    // shopId: {
    //   type: Number,
    //   default: 0,
    // }, // 店铺id
    shopInfo: {
      type: Object,
      default: () => {},
    }, // 店铺信息
  },
  components: {
    feedback,
    // QrcodeVue,
    aiQuestionPopup,
  },

  data() {
    return {
      selectedMenu: "",
      menuList: [
        // {
        //   icon: "moe_right_icon1.png",
        //   activeIcon: "moe_right_icon1_active.png",
        //   text: "伴学师",
        //   menu: 5,
        // },
        // {
        //   icon: "moe_right_icon2.png",
        //   activeIcon: "moe_right_icon2_active.png",
        //   text: "微信客服",
        //   menu: 1,
        // },
        // {
        //   icon: "moe_right_icon5.png",
        //   activeIcon: "moe_right_icon5_active.png",
        //   text: "客服电话1",
        //   menu: 6,
        // },
        // {
        //   icon: "moe_right_icon5.png",
        //   activeIcon: "moe_right_icon5_active.png",
        //   text: "客服电话2",
        //   menu: 7,
        // },
        {
          icon: "moe_right_icon3.png",
          activeIcon: "moe_right_icon3_active.png",
          text: "反馈",
          menu: 2,
        },
        // { icon: 'download.png', activeIcon: 'download_active.png', text: '下载', menu: 3 },
        {
          icon: "moe_right_icon4.png",
          activeIcon: "moe_right_icon4_active.png",
          text: "顶部",
          menu: 4,
        },
      ],
      qrCodeValue: "",
      aiQuestionShow: false,
      companionTeacherQrcode: {}, // 伴学师二维码
      windowWidth: 0,
      windowHeight: 0
    };
  },
  watch: {
    shopInfo: {
      handler() {
        this.updateServiceMenuItem();
      },
      deep: true,
      immediate: true,
    },
    "$route.path": {
      handler() {
        this.updateServiceMenuItem();
      },
      immediate: true,
    },
  },

  mounted() {
    this.qrCodeValue = config.CUSTOMER_LINK;
    // if (this.showCustomer?.showCustomer) {
    // this.menuList = [
    // { icon: 'customer.png', activeIcon: 'customer_active.png', text: '客服', menu: 1 },
    // { icon: 'feedback.png', activeIcon: 'feedback_active.png', text: '反馈', menu: 2 },
    // { icon: 'download.png', activeIcon: 'download_active.png', text: '下载', menu: 3 },
    // { icon: 'top_back.png', activeIcon: 'top_back_active.png', text: '顶部', menu: 4 },
    // ]
    // } else {
    // this.menuList = [
    //   { icon: 'feedback.png', activeIcon: 'feedback_active.png', text: '反馈', menu: 2 },
    //   // { icon: 'download.png', activeIcon: 'download_active.png', text: '下载', menu: 3 },
    //   { icon: 'top_back.png', activeIcon: 'top_back_active.png', text: '顶部', menu: 4 },
    // ];
    // }
    // this.getMenuList();
    this.getCustomerList();
    this.getCustomerCode();
  },

  methods: {
    /**
     * 判断是否展示“客服”按钮：
     * 仅在课程详情页，且店铺信息完整（shopId/shopName/shopLogo）时显示
     * @returns {boolean}
     */
    shouldShowServiceEntry() {
      const isCourseDetailPage = this.$route.path === "/courseDetail";
      const hasCompleteShopInfo =
        Boolean(this.shopInfo?.shopId) &&
        Boolean(this.shopInfo?.shopName) &&
        Boolean(this.shopInfo?.shopLogo);
      return isCourseDetailPage && hasCompleteShopInfo;
    },
    /**
     * 根据页面与店铺信息动态维护“客服”菜单项
     * 说明：满足条件则插入首位，不满足则移除
     */
    updateServiceMenuItem() {
      const serviceMenu = {
        icon: "moe_right_icon6.png",
        activeIcon: "moe_right_icon6_active.png",
        text: "客服",
        menu: 1,
      };
      const serviceIndex = this.menuList.findIndex((item) => item.menu === 1);
      const shouldShow = this.shouldShowServiceEntry();

      if (shouldShow && serviceIndex === -1) {
        this.menuList.unshift(serviceMenu);
        return;
      }
      if (!shouldShow && serviceIndex > -1) {
        this.menuList.splice(serviceIndex, 1);
      }
    },
    /**
     * 获取客服电话列表并插入右侧菜单
     */
    getCustomerList(){
      this.$Api.common.getCustomerList({contactNumber:"",customerName:"",id: null}).then(res=>{
        let customerList = res.data.data;
        customerList.forEach((item,index) =>{
          this.menuList.unshift({
          icon: "moe_right_icon5.png",
          activeIcon: "moe_right_icon5_active.png",
          text: item.customerName,
          menu: index+6,
          phone:item.contactNumber
        })
        })
      }).catch(()=>{})
    },
    /**
     * 获取微信客服二维码并插入右侧菜单
     */
    getCustomerCode(){
      this.$Api.common.getCustomerCode().then(res=>{
        let codeList = res.data.data;
        codeList.forEach((item,index) =>{
          this.menuList.unshift({
          icon: "moe_right_icon2.png",
          activeIcon: "moe_right_icon2_active.png",
          text: `微信客服${codeList.length - index}`,
          menu: index+8,
          qrCodeValue:item.path
        })
        })
      }).catch(()=>{})
    },
    /**
     * 插入“伴学师”菜单
     * @param {string} companionTeacherQrcode 伴学师二维码
     */
    getMenuList(companionTeacherQrcode) {
      if (!companionTeacherQrcode) return;
      // if (!this.companionTeacherQrcode) {
      //   this.menuList.shift();
      // } else {
      this.menuList.unshift({
        icon: "moe_right_icon1.png",
        activeIcon: "moe_right_icon1_active.png",
        text: "伴学师",
        menu: 5,
      });
      // }
    },
    /**
     * 页面回到顶部
     */
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    /**
     * 右侧菜单点击事件
     * @param {Object} info 菜单项
     */
    changeMenu(info) {
      if (info.menu == 4) {
        this.goTop();
      } else if (info.menu == 2) {
        this.$refs.feedback.feedbackShow = true;
      } else if (info.menu == 1) {
        this.$Jump.href("/goEasy/pages/conversations", { ...this.shopInfo, type: "SERVICE", otherType: 'NEW_SERVICE' });
      }
    },
    showActive(info) {
      this.selectedMenu = info.menu;
    },
    hideActive() {
      this.selectedMenu = "";
    },
    openFeedBack() {
      // this.$refs.feedback.feedbackShow = true;
    },
    showAiQuestion() {
      // this.$refs.aiQuestionPopup.showDialogue = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.ai_question {
  position: fixed;
  right: 13px;
  top: 26vh;

  .ai_question_icon {
    width: 104px;
    height: 104px;
  }
}

.right_box {
  position: fixed;
  right: 30px;
  top: 40vh;
  width: 66px;
  // height: 303px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.09);
  border-radius: 33px;

  .right_one {
    position: relative;
    // padding-top: 7px;
    width: 58px;
    height: 72px;
    font-weight: 500;
    font-size: 12px;
    color: #303030;
    // border-bottom: 1px solid rgba(1, 17, 17, 0.1);

    .back_img {
      width: 26px;
      height: 26px;
    }

    .split_line {
      width: 34px;
      height: 1px;
      background: #e8e8e8;
      position: absolute;
      bottom: 0;
    }

    .back_text {
      margin: 7px 0;
    }

    .qrcode_box {
      position: absolute;
      left: -120px;
      background: #ffffff;
      border-radius: 10px;
      padding: 10px;

      .companionTeacherQrcode {
        width: 80px;
        height: 80px;
      }
    }

    .connect_phone {
      left: -140px;
      // width: 123px;
      // height: 65px;
      background: #ffffff;
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.13);
      border-radius: 7px;
      padding-right: 20px;
      font-size: 16px;
    }
  }

  .active_right_one {
    // background: linear-gradient(90deg, #00d5c2, #00d498);
  }

  .border_none {
    border: none;
  }
}
</style>